import { render, staticRenderFns } from "./bottom.vue?vue&type=template&id=99e492c4&scoped=true&"
import script from "./bottom.vue?vue&type=script&lang=js&"
export * from "./bottom.vue?vue&type=script&lang=js&"
import style0 from "./bottom.vue?vue&type=style&index=0&id=99e492c4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99e492c4",
  null
  
)

export default component.exports